import type { DocumentVerdictDto } from 'korint-sdk';
import type { DocumentReview } from '@folio/components/features/document-viewer/types';

export type DocumentReviewStatus = DocumentReview['status'];

export type DocumentReviewFilter = 'all' | 'attention' | 'unclassified' | 'missing';

export type DocumentReviewSummary = {
  receivedCount: number;
  missingRequiredCount: number;
  attentionCount: number;
  unclassifiedCount?: number;
  processingCount: number;
  isLoading: boolean;
  hasError: boolean;
};

const REVIEW_STATUS_BY_VERDICT_STATUS: Record<DocumentVerdictDto['status'], DocumentReviewStatus> =
  {
    PROCESSING: 'processing',
    ATTENTION: 'attention',
    CONFORM: 'checked',
  };

export function toDocumentReview({
  verdict,
  isUploading,
}: {
  verdict?: Pick<DocumentVerdictDto, 'status' | 'reasons' | 'checks'>;
  isUploading: boolean;
}): DocumentReview | undefined {
  if (isUploading) return { status: 'processing', reasons: [] };
  if (!verdict) return undefined;
  return {
    status: REVIEW_STATUS_BY_VERDICT_STATUS[verdict.status],
    reasons: verdict.reasons,
    checks: verdict.checks,
  };
}
